import * as React from 'react';

var isBrowser = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser ? syncFallback : useInsertionEffect || syncFallback;

export { useInsertionEffectAlwaysWithSyncFallback };
//# sourceMappingURL=emotion-use-insertion-effect-with-fallbacks.esm.js.map
